import React from 'react';

const NewsandArticles = () => {
 

    return (
        <div className="p-4 h-[calc(100vh-337px)] flex justify-center items-center relative overflow-hidden">
               <p className="text-2xl font-bold">พบกันเร็วๆนี้</p>
               <img src="/images/icon_hand_left.svg" alt="hand left" className='absolute left-[-100px]' />
               <img src="/images/icon_hand_right.svg" alt="hand right" className='absolute right-[-100px]' />
        </div>
    );
}

export default NewsandArticles;
